import { forwardRef, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { StepProps, StepRef } from "../../types";
import useIsMobile from "components/hooks/useIsMobile";
import { celebrate } from "../../../../common/celebrations";

export default forwardRef<StepRef, StepProps>(({ onNext, disabled }, _ref) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      celebrate();
    }, 400);
    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "center",
        padding: isMobile ? "24px 8px 0" : "48px 32px 0",
        gap: isMobile ? "20px" : "44px",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flex: isMobile ? 1 : 1.15,
          maxWidth: isMobile ? "100%" : "max-content",
          width: isMobile ? "100%" : "auto",
          justifyContent: "center",
          alignSelf: isMobile ? "center" : "flex-start",
          pt: isMobile ? 0 : 6,
        }}
      >
        <img
          src="/assets/images/nux/high-five.gif"
          style={{
            width: "100%",
            maxWidth: isMobile ? "300px" : "430px",
            borderRadius: "16px",
            maxHeight: isMobile ? "36vh" : "460px",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flex: isMobile ? 1 : 0.72,
          maxWidth: "430px",
          width: "100%",
          padding: isMobile ? "0 8px" : "",
          pt: isMobile ? 0 : 10,
        }}
      >
        <Typography
          variant={isMobile ? "h2" : "h1"}
          sx={{
            fontSize: isMobile ? "22px" : "auto",
            marginBottom: isMobile ? "16px" : "32px",
          }}
        >
          You're in!
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginBottom: isMobile ? "24px" : "32px",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 500 }}></Typography>
          <Typography variant="body1">
            The next few steps are optional but worth it — they help your agent
            understand your household so it hits the ground running.
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size={isMobile ? "medium" : "large"}
            disabled={disabled}
            onClick={() => onNext?.()}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
});
